import { PERMISSIONS, PERMISSION_ABILITY } from "../../../constants"
import { AuthorityList } from "../components/AuthorityList";
import { RoleList } from "../components/RoleList";
import { SoftwareUsage } from "../components/SoftwareUsage";
import ToolSupport from "../components/ToolSupport";
import { UnitList } from "../components/UnitList";
import { UserList } from "../components/UserList";
import { IAuth, IRole, ITabManager, IToolSupportParams, IUser, IuserByUnit } from "../models/managerModels";

export const KEY_TAB = {
  ROLE: "role",
  AUTHORITY: "authority",
  UNIT: "unit",
  USER: "user",
  SOFTWARE_USAGE: "softwareUsage",
  TOOL_SUPPORT: "toolSupport"
}

export const LIST_TAB: ITabManager[] = [
  {
    key: KEY_TAB.ROLE,
    permission: PERMISSIONS.ROLE,
    ability: PERMISSION_ABILITY.VIEW,
    icon: "/media/icons/box-fill.svg",
    title: "ROLE",
    Component: RoleList
  },
  {
    key: KEY_TAB.AUTHORITY,
    permission: PERMISSIONS.AUTHORITY,
    ability: PERMISSION_ABILITY.VIEW,
    icon: "/media/icons/key-fill.svg",
    title: "AUTH",
    Component: AuthorityList
  },
  {
    key: KEY_TAB.UNIT,
    permission: PERMISSIONS.ORGANIZATION_MENU,
    ability: PERMISSION_ABILITY.VIEW,
    icon: "/media/icons/building-fill.svg",
    title: "UNIT",
    Component: UnitList
  },
  {
    key: KEY_TAB.USER,
    permission: PERMISSIONS.MANAGEMENT_UNIT,
    ability: PERMISSION_ABILITY.VIEW,
    icon: "/media/icons/person-fill.svg",
    title: "USER",
    Component: UserList
  },
  {
    key: KEY_TAB.SOFTWARE_USAGE,
    permission: PERMISSIONS.SOFTWARE_USAGE,
    ability: PERMISSION_ABILITY.VIEW,
    icon: "/media/icons/chart-line-up.svg",
    title: "SOFTWARE_USAGE",
    Component: SoftwareUsage
  },
  {
    key: KEY_TAB.TOOL_SUPPORT,
    permission: PERMISSIONS.TOOL_SUPPORT,
    ability: PERMISSION_ABILITY.VIEW,
    icon: "/media/icons/briefcase-fill.svg",
    title: "TOOL_SUPPORT",
    Component: ToolSupport
  }
]

export const INIT_USER: IuserByUnit = {
  id: "",
  user: {
    username: "",
    password: "",
    confirmPassword: "",
    email: "",
    phone: "",
    roles: [],
    organization: null
  } as IUser,
  employee: null,
  organization: null,
  orgId: "",
  createDate: "",
  createdBy: "",
  modifiedBy: "",
  modifyDate: ""
};

export const INIT_AUTH: IAuth = {
  id: "",
  name: "",
  code: ""
};

export const INIT_ROLE: IRole = {
  id: "",
  orgId: "",
  name: "",
  description: "",
  authorities: []
};

export const TYPE_SOFTWARE_USAGE = 18;

export const LIST_STATUS_SOFTWARE_USAGE = [
  {
    maxValue: 0.3,
    className: "bg-coral"
  },
  {
    maxValue: 0.5,
    className: "bg-orange-dark"
  },
  {
    maxValue: 0.7,
    className: "bg-amber"
  },
  {
    maxValue: 1,
    className: "bg-green"
  },
];

export const INIT_TOOL_SUPPORT_PARAMS: IToolSupportParams = {
  option: null,
  date: null
}

export const LIST_INFO_UPDATE_EMPLOYEE = [
  {
    code: 1,
    name: "Thông tin hưu"
  },
  {
    code: 2,
    name: "Thông tin hợp đồng"
  },
  {
    code: 3,
    name: "Thông tin lương"
  },
]